import { render } from "./PermissionNew.vue?vue&type=template&id=f6b91a76&scoped=true"
import script from "./PermissionNew.vue?vue&type=script&lang=js"
export * from "./PermissionNew.vue?vue&type=script&lang=js"

import "./PermissionNew.vue?vue&type=style&index=0&id=f6b91a76&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b91a76"]])

export default __exports__